import Cookies from 'universal-cookie';
import {
  ACTIVE_ACCOUNT_HEADER,
  ACTIVE_SESSION_HEADER,
  activeAccountIdStore,
  activeSessionIdStore,
} from '@customerio/hydra-session-state';
import { getAppVersion } from '@/utils/version';
import { isEmptyString } from '@/utils/string';

/**
 * Shared auth/session headers for Services API requests.
 *
 * Used by ts-rest, legacy axios clients, and raw fetch callers (multipart
 * uploads) so auth header changes happen in one place.
 */
export function getAuthHeaders(): Record<string, string> {
  const cookies = new Cookies();
  const accessToken = cookies.get('_access');

  return {
    'x-ui-version': getAppVersion(),
    [ACTIVE_SESSION_HEADER]: activeSessionIdStore.get().toString(),
    [ACTIVE_ACCOUNT_HEADER]: activeAccountIdStore.get().toString(),
    ...(isEmptyString(accessToken) ? {} : { Authorization: `Bearer ${accessToken}` }),
  };
}
